import { FileStatus } from 'store/fileState/types';
import { checkIfRoleIsIncluded, UserRole } from 'auth/checkRole';

export const isEditable = (
  isApprover: (roles: UserRole) => boolean,
  fileStatus: FileStatus,
) => {
  return (
    fileStatus === FileStatus.EDIT ||
    (fileStatus === FileStatus.TEMPLATE && isApprover(UserRole.APPROVER))
  );
};

export const isEditableWithoutUseAuth = (fileStatus: FileStatus) => {
  return (
    fileStatus === FileStatus.EDIT ||
    (fileStatus === FileStatus.TEMPLATE &&
      checkIfRoleIsIncluded(UserRole.APPROVER))
  );
};
